/*
 * Mini Maya Club — premium redesign helper script.
 * Only touches presentation (carousel arrows). Native horizontal
 * scroll + scroll-snap already provides touch/swipe support, so this
 * just wires up the optional arrow buttons.
 */
(function () {
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    var track = root.querySelector('.mmc-carousel__track');
    var prevBtn = root.querySelector('.mmc-carousel__arrow--prev');
    var nextBtn = root.querySelector('.mmc-carousel__arrow--next');
    if (!track) return;

    function updateArrowState() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollByPage(direction) {
      var amount = track.clientWidth * 0.85 * direction;
      track.scrollBy({
        left: amount,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByPage(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByPage(1);
      });
    }

    var scrollTimeout;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(updateArrowState, 50);
      },
      { passive: true }
    );

    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  }

  function initAll() {
    document.querySelectorAll('.mmc-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a carousel section is added/edited live in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector && event.target.querySelector('.mmc-carousel');
    if (el) initCarousel(el);
  });
})();
